import React from 'react'
import { AppBar, IconButton, ListItem, ListItemAvatar, ListItemText, Toolbar } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded'
import { shallowEqual, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import WeekDayIcon from 'components/customer-details/content/routing/WeekDayIcon'
import { deserializeDate, formatDateToFEFormatDateFns } from 'utils/date'

const ScheduleStopDialogAppBar = ({ onClose }) => {
  const stopToBeAssigned = useSelector(s => s.routingActions.assignStopDialog.stopToBeAssigned, shallowEqual)
  const addressStr = get(stopToBeAssigned, 'addressStr')
  const serviceName = get(stopToBeAssigned, 'accountName')
  const actionSerializedServiceDate = useSelector(state => get(state, 'routingActions.actionSerializedServiceDate'))
  const routingSerializedServiceDate = useSelector(state => get(state, 'CustomerDetails.routing.serializedServiceDate'))
  const serializedServiceDate = actionSerializedServiceDate || routingSerializedServiceDate
  const serviceDate = serializedServiceDate ? deserializeDate(serializedServiceDate) : new Date()
  const dayOfWeek = serviceDate.getDay()
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  const day = days[dayOfWeek]
  const formattedDate = formatDateToFEFormatDateFns(serviceDate)

  return (
    <AppBar elevation={0} sx={{ position: 'relative' }}>
      <Toolbar>
        <IconButton edge="start" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
        <ListItem disableGutters>
          <ListItemAvatar sx={{ minWidth: 0, mr: 2 }}>
            <WeekDayIcon day={day} variant="active" />
          </ListItemAvatar>
          <ListItemText
            primary={serviceName}
            secondary={addressStr}
            slotProps={{
              primary: { color: 'textPrimary', variant: 'h4', fontWeight: 600 },
              secondary: { color: 'textSecondary' },
            }}
          />
        </ListItem>
        <ListItem disableGutters sx={{ ml: 'auto', width: 'auto' }}>
          <ListItemAvatar sx={{ minWidth: 0, mr: 1 }}>
            <CalendarTodayRoundedIcon sx={{ opacity: 0.7, fontSize: 18 }} />
          </ListItemAvatar>
          <ListItemText
            primary={formattedDate}
            secondary={day}
            slotProps={{
              primary: { color: 'textPrimary', variant: 'h5', fontWeight: 600, noWrap: true },
              secondary: { color: 'textSecondary', noWrap: true },
            }}
          />
        </ListItem>
      </Toolbar>
    </AppBar>
  )
}

ScheduleStopDialogAppBar.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default ScheduleStopDialogAppBar
